module.exports = __webpack_public_path__ + "static/burg4-820316482d23293440a762c62ff3e7c1.jpg";